export const getMonthName = (timestamp: string) => {
  const date = new Date(timestamp);
  const month = date.toLocaleString("default", { month: "short" });
  return month;
};

export const getDay = (timestamp: string) => {
  const date = new Date(timestamp);
  const day = date.getDate();
  return day;
};

export const getTime = (timestamp: string) => {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  return `${hours}:${minutes} ${ampm}`;
};

export const getAllowedTime = (allowedTime: string) => {
  const date = allowedTime.split(":");
  const getformatNumber = (n: string) => (n.length === 1 ? `0${n}` : n);
  return `${getformatNumber(date[0])}:${getformatNumber(date[1])}`;
};

export const getAcademicYearDates = () => {
  const today = new Date();
  const currentYear = today.getFullYear();

  const startOfAcademicYear = new Date(currentYear, 7, 1);
  const endOfAcademicYear = new Date(currentYear + 1, 4, 31);

  const formatDate = (date: any) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

  return {
    start_date: formatDate(startOfAcademicYear),
    end_date: formatDate(endOfAcademicYear),
  };
};

export const getAmericanDateTime = (timestamp: string) => {
  const date = new Date(timestamp);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZone: "America/New_York",
  };

  return date.toLocaleString("en-US", options);
};
